import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { StoreInterfaces } from "../../types/store/StoreInterfaces"; 
import { setLanguage } from "../../store/UI"; 

export function useTranslationHook(): {
  changeLanguage: (param: string) => void;
  t: (param: string | undefined) => string;
  currentLanguage: string;
} {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const currentLanguage = useSelector((state: StoreInterfaces) => state.ui.language);

  const changeLanguage = (language: string) => {
    dispatch(setLanguage(language)); 
    i18n.changeLanguage(language); 
    localStorage.setItem('language', language);
  };

  const trans = (sentence: string | undefined) => {
    return sentence ? t(sentence) : '';
  };

  return { changeLanguage, t: trans, currentLanguage };
}
